module.exports = {
  ads: {
    developerToken: 'MkZe21jJJyfy-wg8iifa6Q',
    loginCustomerId: '3025257709'
  }
}
